import React from 'react'
import classNames from 'classnames'
import styles from './Heading.module.scss'

const HeadingComponent = React.memo(function Heading(props) {
  const { level, type, children, noMargin, styleClass } = props
  const Component =
    level === 1
      ? 'h1'
      : level === 2
      ? 'h2'
      : level === 3
      ? 'h3'
      : level === 4
      ? 'h4'
      : level === 5
      ? 'h5'
      : 'h6'

  const classes = classNames(
    styles.heading,
    styles[`heading-${type}`],
    { [styles.noMargin]: noMargin },
    styleClass
  )

  return <Component className={classes}>{children}</Component>
})

export default HeadingComponent
